/**
 * RBAC helpers for job billing workspace (operations / Smart Task teams).
 * Owner and root always pass billing workspace toggles and job-invoice generation; others follow team feature flags.
 */

export const OPERATIONS_JOB_BILLING_WORKSPACE_KEY = 'operations_job_billing_workspace';
export const OPERATIONS_JOB_GENERATE_INVOICE_KEY = 'operations_job_generate_invoice';
export const OPERATIONS_JOB_BILLING_TIMERS_SIGNOFF_KEY = 'operations_job_billing_timers_signoff';
export const OPERATIONS_JOB_EDIT_TIMERS_FOR_COMPLETION_KEY = 'operations_job_edit_timers_for_completion';
export const OPERATIONS_JOB_BILLING_FINALIZE_KEY = 'operations_job_billing_finalize';

type Settings = Record<string, unknown> | null | undefined;

export function isOperationsJobBillingWorkspaceAllowed(settings: Settings, opts: { isOwnerOrRoot: boolean }): boolean {
  if (opts.isOwnerOrRoot) {
    return true;
  }
  return settings?.[OPERATIONS_JOB_BILLING_WORKSPACE_KEY] !== false;
}

/** Platform root or active client owner (membership) may generate job invoices regardless of `operations_job_generate_invoice`. */
export function isOperationsJobGenerateInvoiceAllowed(
  settings: Settings,
  opts: { isOwnerOrRoot: boolean },
): boolean {
  if (opts.isOwnerOrRoot) {
    return true;
  }
  return settings?.[OPERATIONS_JOB_GENERATE_INVOICE_KEY] === true;
}

/** Allow review, edit, and sign-off on SmartTask timer entries in the work item Billing tab. */
export function isOperationsJobBillingTimersSignoffAllowed(
  settings: Settings,
  opts: { isOwnerOrRoot: boolean },
): boolean {
  if (opts.isOwnerOrRoot) {
    return true;
  }
  return settings?.[OPERATIONS_JOB_BILLING_TIMERS_SIGNOFF_KEY] === true;
}

/** Allow editing timer entries when completing jobs from the work item modal. */
export function isOperationsJobEditTimersForCompletionAllowed(
  settings: Settings,
  opts: { isOwnerOrRoot: boolean },
): boolean {
  if (opts.isOwnerOrRoot) {
    return true;
  }
  return settings?.[OPERATIONS_JOB_EDIT_TIMERS_FOR_COMPLETION_KEY] !== false;
}

/** Allow determination and finalization of billing lines, expenses, and rates. */
export function isOperationsJobBillingFinalizeAllowed(
  settings: Settings,
  opts: { isOwnerOrRoot: boolean },
): boolean {
  if (opts.isOwnerOrRoot) {
    return true;
  }
  return settings?.[OPERATIONS_JOB_BILLING_FINALIZE_KEY] === true;
}
